const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');
const getProductionPublicUrl = () => {
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.protocol &&
    window.location.host
  ) {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return 'https://salew-bot.ru';
};

const toWebSocketUrl = (value) => {
  const normalized = trimTrailingSlash(value);
  if (normalized.indexOf('https://') === 0) {
    return `wss://${normalized.slice('https://'.length)}`;
  }
  if (normalized.indexOf('http://') === 0) {
    return `ws://${normalized.slice('http://'.length)}`;
  }
  return normalized;
};

const isDevelopment = process.env.NODE_ENV === 'development';
const PRODUCTION_PUBLIC_URL = trimTrailingSlash(getProductionPublicUrl());

export const API_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_API_URL || 'http://127.0.0.1:50003')
  : `${PRODUCTION_PUBLIC_URL}/api`);

export const WS_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_WS_URL || 'ws://127.0.0.1:1825')
  : toWebSocketUrl(PRODUCTION_PUBLIC_URL));

export const PUBLIC_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_PUBLIC_URL || 'http://127.0.0.1:3000')
  : PRODUCTION_PUBLIC_URL);
